import { render } from "./investors-panel-accordion.vue?vue&type=template&id=4d067b2b&scoped=true&ts=true"
import script from "./investors-panel-accordion.vue?vue&type=script&lang=ts"
export * from "./investors-panel-accordion.vue?vue&type=script&lang=ts"

import "./investors-panel-accordion.vue?vue&type=style&index=0&id=4d067b2b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d067b2b"]])

export default __exports__